import * as React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * Shared SectionSelector component for resume form navigation
 * Uses shadcn/ui Button components for modern design
 * @param {Array} sections - Array of section objects with {id, label}
 * @param {string} activeSection - Currently active section ID
 * @param {Function} onSectionChange - Callback function when section is clicked
 */
const SectionSelector = ({ sections = [], activeSection, onSectionChange }) => {
  return (
    <div className="flex flex-wrap gap-2 p-5 bg-muted/50 border-b">
      {sections.map((section) => (
        <Button
          key={section.id}
          variant={activeSection === section.id ? "default" : "outline"}
          size="sm"
          onClick={() => onSectionChange(section.id)}
          className={cn(
            "transition-all",
            activeSection === section.id && "shadow-md"
          )}
        >
          {section.label}
        </Button>
      ))}
    </div>
  );
};

export default SectionSelector;
